<template>
  <div class="app-container ranking-detail">
    <basic-container>
      <avue-crud ref="crud"
        :option="tableOption"
        :data="tableData"
        :page="page"
        :table-loading="tableLoading"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">

        <template slot="ranking" slot-scope="scope">
          <div class="ranking-list-container-ranking-font">{{scope.row.ranking}}</div>
        </template>

        <template slot="nickname" slot-scope="scope">
          <a href="javascript:void(0);" @click="toMemberDetail(scope.row.memberId);"
              class="ranking-list-container-button">
            {{scope.row.nickname}}</a>
        </template>

        <template slot="postTitle" slot-scope="scope">
          <div class="title">
            <div class="post-cover-image" v-if="scope.row.postCoverImg" >
              <img :src="scope.row.postCoverImg" @click="toPostDetail(scope.row.postId);">
            </div>
            <a href="javascript:void(0);" @click="toPostDetail(scope.row.postId);"
                class="ranking-list-container-button">
              {{scope.row.postTitle}}
            </a>
          </div>
        </template>

      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
  import {fetchRankingDetail} from '@/api/analysis/rankingAnalysis'
  import {rankingTypes, rankingTargetTypes, rankingPeroidTypes} from '@/const/crud/analysis/rankingAnalysis'

  export default {
    data () {
      return {
        search: {
          current: 1,
          size: 10,
        },
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
        },
        tableData: [],
        tableOption: undefined,
        rankingId: undefined,
        rankingTypes,
        rankingTargetTypes,
        rankingPeroidTypes,
        isMemberForRanking: false,
        isPostForRanking: false,
        tableLoading: false,
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init() {
        this.rankingId = this.$route.query.id
        this.tableOption = rankingTargetTypes.find(item => item.label === this.$route.query.target).tableOption
        this.tableOption.column[this.tableOption.column.findIndex(item => item.prop === 'rankingValue')].label = this.$route.query.type
        this.getRankingDetail()
      },
      getRankingDetail() {
        let params = {
          current: this.search.current,
          size: this.search.size,
          rankingId: this.rankingId,
        }
        this.tableLoading = true
        fetchRankingDetail(params).then(response => {
          this.tableData = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.tableLoading = false
        }).catch(error => {
          this.$message({
            message: '获取排行榜详情信息失败',
            type: 'error'
          })
        })
      },
      formatData(records) {
        if (!records && records.length < 0) {
          return records
        }
        let tempTableDatas=[]
        // ranking about member
        if (this.tableOption.about === 'member') {
          records.forEach(function(record, index) {
            let tempTableData ={}
            tempTableData.memberId = record.rankingDetailAbout.memberId
            tempTableData.ranking = record.ranking
            tempTableData.rankingValue = record.rankingValue
            tempTableData.rankingExtraInfo = record.rankingExtraInfo || '--'
            tempTableData.nickname = record.rankingDetailAbout.nickname || '--'
            tempTableData.realname = record.rankingDetailAbout.realname || '--'
            tempTableData.unionId = record.rankingDetailAbout.unionId || '--'
            tempTableDatas.push(tempTableData)
          })
        }
        // ranking about post
        if (this.tableOption.about === 'post') {
          records.forEach(function(record, index) {
            let tempTableData ={}
            tempTableData.postId = record.rankingDetailAbout.postId
            tempTableData.ranking = record.ranking
            tempTableData.rankingValue = record.rankingValue
            tempTableData.rankingExtraInfo = record.rankingExtraInfo || '--'
            tempTableData.postTitle = record.rankingDetailAbout.postTitle || '--'
            tempTableData.postCoverImg = record.rankingDetailAbout.postCoverImg
            tempTableData.memberId = record.rankingDetailAbout.memberId
            tempTableData.nickname = record.rankingDetailAbout.nickname || '--'
            tempTableData.realname = record.rankingDetailAbout.realname || '--'
            tempTableData.unionId = record.rankingDetailAbout.unionId || '--'
            tempTableDatas.push(tempTableData)
          })
        }
        return tempTableDatas
      },
      toMemberDetail(id) {
        this.$router.push({
          path: `/upms/member/detail/${id}`,
        })
      },
      toPostDetail(id) {
        if (id){
          this.$router.push({
            path: `/content/list/detail/${id}`
          })
        } else {
          this.$message({
            showClose: true,
            message: '该帖子不存在',
            type: 'warning'
          })
        }
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getRankingDetail()
      },
      handleSizeChange(val) {
        this.page.pageSize = val
        this.search.size = val
        this.getRankingDetail()
      },
    },
  }
</script>

<style  lang="scss" scoped>
.ranking-detail {
  .ranking-detail-item {
    font-size: 16px;
    margin: 10px 0;
  }
}
.ranking-list-container {
  padding-top: 0px;
  &-ranking-font {
    font-size: 15px;
    font-weight: bolder;
  }
  &-button {
    color: #409EFF;
    font-size: 14px;
    text-align: center;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 170px;
    text-align: left;
  }
}
.title {
  display: flex;
  align-items: center;
  .post-cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}
</style>